function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Hide = function Hide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M12.15 3c2.046.012 4.026.609 5.816 1.731l1.439-1.438a.999.999 0 1 1 1.414 1.414L5.023 20.503a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l1.311-1.312A13.3 13.3 0 0 1 2.62 15.23c-.457-.655-.824-1.337-1.18-1.996l-.1-.188c-.66-1.221-.214-2.084.143-2.777.349-.677.731-1.315 1.137-1.9C4.94 5.029 8.503 3.022 12.15 3m9.3 4.951q.154.206.301.418c.405.583.788 1.222 1.137 1.899.357.693.802 1.556.143 2.776l-.1.189c-.357.659-.724 1.341-1.18 1.997-2.329 3.351-5.904 5.358-9.564 5.367a10.4 10.4 0 0 1-2.792-.393 1 1 0 0 1 .542-1.925c.744.21 1.5.316 2.25.318 3.001-.008 5.965-1.693 7.921-4.509.392-.563.717-1.166 1.061-1.804l.102-.19c.14-.259.158-.292-.16-.91a15 15 0 0 0-1.259-2.029 1.001 1.001 0 0 1 1.597-1.204M12.207 5c-3.043.017-5.996 1.704-7.946 4.51a15 15 0 0 0-1.002 1.674c-.32.618-.301.65-.161.91l.101.19c.345.638.67 1.24 1.061 1.803a11.3 11.3 0 0 0 2.08 2.27l1.96-1.96a4.675 4.675 0 0 1 6.48-6.48l1.727-1.728c-1.365-.772-2.835-1.18-4.3-1.19m-.023 4.13a2.673 2.673 0 0 0-2.42 3.802l3.552-3.552a2.7 2.7 0 0 0-1.132-.25"
  }));
};
export default Hide;